import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { setupGlobalErrorHandlers } from './utils/errorHandler';

// Initialize Sentry as early as possible
Sentry.init({
  dsn: 'https://6913ad1e1019348012c78f20804272b4@o4509857623179264.ingest.us.sentry.io/4509857624621056',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Removed replayIntegration() to significantly reduce bundle size
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
  // Setting this option to true will send default PII data to Sentry.
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || 'development',
});

// Firebase App (the core Firebase SDK) is always required and must be listed first
var firebaseConfig = {
  apiKey: 'AIzaSyB0H4TlU6AL3E-rrvrbVEqA71IsIJHAFTc',
  authDomain: 'ventscape-9f566.firebaseapp.com',
  projectId: 'ventscape-9f566',
  storageBucket: 'ventscape-9f566.appspot.com',
  messagingSenderId: '50234146469',
  appId: '1:50234146469:web:2b8f68a7ae3ea78ae3974c',
  measurementId: 'G-RSMEGEMRZZ',
};

initializeApp(firebaseConfig);
const analytics = getAnalytics();
logEvent(analytics, 'app_started');
console.log('?');

// Setup global error handlers for better error tracking
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>An error occurred. Please refresh the page.</div>} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
